var _document;
import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('payments-ui', {
  dimensions: {
    is_acceptance_test: JSON.stringify(!!((_document = document) !== null && _document !== void 0 && (_document = _document.cookie) !== null && _document !== void 0 && _document.includes('hs_selenium')))
  }
});